import { JSX } from 'react';
import './iconButton.css';

interface IconButtonProps {
    src: string,
    alt?: string,
    clickFunction: () => void,

}

const IconButton = ({src, alt, clickFunction}: IconButtonProps): JSX.Element => {
    return (
        <button className='close-button' onClick={() => clickFunction()}>
            <img src={src} alt={alt} className="icon-button-image"/>
        </button>
    ); 
};
      
export default IconButton;